var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.searchData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.resetForm("ruleForm")
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.searchData,
            rules: _vm.rules,
            "label-width": "180px"
          }
        },
        [
          _vm.rawData.game_show_type == 1
            ? _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "special_product_id", label: "选择产品" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择产品"
                      },
                      on: { change: _vm.productChange },
                      model: {
                        value: _vm.searchData.special_product_id,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "special_product_id", $$v)
                        },
                        expression: "searchData.special_product_id"
                      }
                    },
                    _vm._l(_vm.productsList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "广告经理ID", prop: "login_customer_id" }
            },
            [
              _c("el-input", {
                staticClass: "operationFrame-entity",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.searchData.login_customer_id,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "login_customer_id", $$v)
                  },
                  expression: "searchData.login_customer_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "广告客户ID", prop: "customer_id" }
            },
            [
              _c("el-input", {
                staticClass: "operationFrame-entity",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.searchData.customer_id,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "customer_id", $$v)
                  },
                  expression: "searchData.customer_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "广告平台开发者Token", prop: "developer_token" }
            },
            [
              _c("el-input", {
                staticClass: "operationFrame-entity",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.searchData.developer_token,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "developer_token", $$v)
                  },
                  expression: "searchData.developer_token"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.resetForm("ruleForm")
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.interdits, type: "warning" },
              on: {
                click: function($event) {
                  return _vm.clearData()
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit("ruleForm")
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }